export const limpiaParametrosVacios = params => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== null)
  );
  return filteredParams;
};
